import { action, computed, observable } from 'mobx';
import { UserType } from '../../../constants/UserTypeEnum';
export class Overlay {
    @observable public userType?: UserType;
    @observable public isFormLoading: boolean = false;

    @computed
    public get isExistingUser() {
        return this.userType !== undefined;
    }

    @action
    public setUserType(userType?: UserType) {
        this.userType = userType;
    }

    @action
    public setFormLoading = (isLoading: boolean) => {
        this.isFormLoading = isLoading;
    };
}
